export enum SubscriptionStatus {
  Active = 1,
  Canceled = 5,
}
